/** Выбор усиления «1 из 3» — представление без стора, всё приходит пропсами. */
import { BoostIcon, Icon, TAP_GUARD_MS, WindowShell } from "../kit";
import { type BoostOption } from "@newfungame/engine";
import { nameKey } from "../format";
import { useT } from "../../../app";
import "./styles.css";

export interface BoostChoiceViewProps {
  /** Пройденная волна — «Волна N пройдена!»; `null` — без строки. */
  wave: number | null;
  /** Заголовок вместо «Волна N пройдена!» (подкрепление после реванша); подзаголовок тот же. */
  heading?: string;
  kind?: "boostChoice" | "reviveBoost";
  /** Ответ сервера ещё не пришёл: карточки не принимают тап. */
  busy?: boolean;
  options: readonly BoostOption[];
  /** Индекс карточки с советом (рамка и палец); `null` — без совета. */
  hint: number | null;
  onChoose(index: number): void;
}

export function BoostChoiceView(props: BoostChoiceViewProps) {
  const { wave, options, hint, onChoose, heading, kind = "boostChoice", busy = false } = props;
  const t = useT();
  const title = heading ?? (wave ? t("win.boost.cleared", { n: wave }) : t("win.boost.title"));
  return (
    <WindowShell kind={kind} title={title} guardMs={TAP_GUARD_MS}>
      {heading || wave ? <p class="win-subtitle">{t("win.boost.title")}</p> : null}
      <div class="win-boosts">
        {options.map((o) => {
          const key = nameKey("boost", o.boostId);
          const hinted = hint === o.index;
          return (
            <button
              type="button"
              key={o.index}
              class={`win-boost win-boost--${o.rarity}${hinted ? " win-boost--hint" : ""}`}
              data-testid={`boost-${o.index}`}
              data-boost={o.boostId}
              data-hint={hinted ? "1" : undefined}
              disabled={busy}
              onClick={() => onChoose(o.index)}
            >
              <BoostIcon boostId={o.boostId} size={44} class="win-boost__icon" />
              <span class="win-boost__name">{t(`${key}.name`)}</span>
              <span class="win-boost__effect">{t(`${key}.description`)}</span>
              {o.maxStacks === null ? (
                <span class="win-boost__stacks">∞</span>
              ) : (
                o.stacks > 0 && (
                  <span class="win-boost__stacks">{t("win.boost.taken", { n: o.stacks, max: o.maxStacks })}</span>
                )
              )}
              {o.rarity !== "common" && <span class="win-boost__rarity">{t(`win.boost.rarity.${o.rarity}`)}</span>}
              {hinted && (
                <span class="win-boost__finger" title={t("win.boost.hint")} data-testid="boost-hint">
                  <Icon name="finger" size={48} />
                </span>
              )}
            </button>
          );
        })}
      </div>
    </WindowShell>
  );
}
